import { CREATE_PSYCHOLOGIST } from '../psychologist/actionsTypes';
import { FETCH_PSYCHOLOGISTS } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  isAuth: false,
  data: [],
};

const psychologistsReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_PSYCHOLOGISTS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_PSYCHOLOGISTS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_PSYCHOLOGISTS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_PSYCHOLOGIST}_FULFILLED`:
      return {
        ...state,
        data: [...state.data, payload],
      };

    default:
      return state;
  }
};

export default psychologistsReducer;
